exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scope-assessment[data-v-281f9518] .ant-select {\n  max-height: 80px !important;\n  overflow-y: auto !important;\n}\n.create-plan-modal[data-v-281f9518] .ant-modal-header {\n  border-bottom: none;\n}\n.create-plan-modal[data-v-281f9518] .ant-modal-body {\n  padding: 0 20px;\n}\n.create-plan-modal[data-v-281f9518] .ant-modal-header {\n  padding: 10px 24px;\n}\n", ""]);

// exports
